import type { BranchCheckoutMode } from "./BranchCheckoutSettingsStore";

type BranchCheckoutSettings = {
	mode: BranchCheckoutMode;
	hideConfirmation: boolean;
};

export const getBranchCheckoutDecision = (localChanges: readonly unknown[], settings: BranchCheckoutSettings) => {
	return {
		mode: settings.mode,
		needsConfirmation: !settings.hideConfirmation && settings.mode === "transfer" && localChanges.length > 0,
		blocked: settings.mode === "block" && localChanges.length > 0,
	};
};
